/**
 * @example font-face object
 'Open Sans' : {
  300 : 'open-sans-light.woff2',
  400 : {
    normal : 'open-sans-normal.woff2',
    italic : 'open-sans-normal-italic.woff2'
  },
  600 : 'open-sans-semibold.woff2',
  700 : 'open-sans-bold.woff2'
}
 */
export type FontFaceType = {
  [fontFamily: string]: {
    [fontWeight: number]:
      | string
      | {
          [fontStyle in 'normal' | 'italic']: string;
        };
  };
};

const getFontFormat = (src: string) => {
  const type = src.split('.').pop();
  switch (type) {
    case 'ttf':
      return 'truetype';
    case 'otf':
      return 'opentype';
    default:
      return type;
  }
};

const getDeclaration = (fontFamily: string, fontWeight: string, fontStyle: string, src: string) => `
  @font-face {
    font-family: "${fontFamily}";
    font-weight: ${fontWeight};
    font-style: ${fontStyle};
    src: local("☺︎"), url("${src}") format("${getFontFormat(src)}");
    font-display: swap;
  }
`;

const generateFontFaceDeclarations = (fontFaces: FontFaceType) => {
  const fontDeclarations: string[] = [];

  // eslint-disable-next-line array-callback-return
  Object.entries(fontFaces).map(([fontFamily, fontWeights]) => {
    // eslint-disable-next-line array-callback-return
    Object.entries(fontWeights).map(([fontWeight, src]) => {
      if (typeof src === 'object') {
        // eslint-disable-next-line array-callback-return
        Object.entries(src).map(([fontStyle, styleSrc]) => {
          fontDeclarations.push(getDeclaration(fontFamily, fontWeight, fontStyle, styleSrc));
        });
      } else {
        fontDeclarations.push(getDeclaration(fontFamily, fontWeight, 'normal', src));
      }
    });
  });

  return fontDeclarations.join('');
};

// eslint-disable-next-line import/no-default-export
export default generateFontFaceDeclarations;
